import React from "react";
import Skeleton from "@mui/material/Skeleton";

const MapSkeleton = ({ style }) => {
    return <Skeleton sx={{ bgcolor: "grey.900", borderRadius: "5px", ...style }} variant="rectangular" height={"100%"} width={"100%"} />;
};

export default MapSkeleton;
